export default "/images/vendor/flag-icon-css/flags/1x1/mg.svg?5bdc14fe1aa439d1a0b7bec9890f0ef8";